import styled from "styled-components";
import React from "react";
import {themecolors} from "../utils/themecolors";

const ErrorContainer = styled.p`
  text-align: center;
  margin-top: 16px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
`;

const ErrorMessage = ({error}) => (
    error &&
        <ErrorContainer>
            {error.toString()}
        </ErrorContainer>
);

export default ErrorMessage;
